const listeners = new Set<Function>();
let currentState = 'idle';

export const voiceState = {
    get state() {
        return currentState;
    },
    set(newState: string) {
        if (currentState === newState) return;
        currentState = newState;
        listeners.forEach(fn => fn(currentState));
    },
    subscribe(callback: Function) {
        listeners.add(callback);
        return () => listeners.delete(callback);
    }
};
